export default __webpack_public_path__ + "static/media/3.6ab8cc41.jpg";